import { render, staticRenderFns } from "./ComplianceSettings.vue?vue&type=template&id=4a38a633&"
import script from "./ComplianceSettings.vue?vue&type=script&lang=js&"
export * from "./ComplianceSettings.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports